export type EffectiveType = 'slow-2g' | '2g' | '3g' | '4g' | 'unknown';

export interface NetworkSnapshot {
  effectiveType: EffectiveType;
  downlink: number | null;
  rtt: number | null;
  saveData: boolean | null;
  online: boolean;
}

interface NetworkInformation {
  effectiveType?: EffectiveType;
  downlink?: number;
  rtt?: number;
  saveData?: boolean;
}

type NavigatorWithConnection = Navigator & { connection?: NetworkInformation };

export function getNetworkSnapshot(): NetworkSnapshot {
  if (typeof navigator === 'undefined') {
    return { effectiveType: 'unknown', downlink: null, rtt: null, saveData: null, online: true };
  }
  const conn = (navigator as NavigatorWithConnection).connection;
  return {
    effectiveType: conn?.effectiveType ?? 'unknown',
    downlink: typeof conn?.downlink === 'number' ? conn.downlink : null,
    rtt: typeof conn?.rtt === 'number' ? conn.rtt : null,
    saveData: typeof conn?.saveData === 'boolean' ? conn.saveData : null,
    online: navigator.onLine,
  };
}
